/**
 * define the resource schema
 */
import { createI18n, type I18nOptions } from 'vue-i18n'

import enUS from './en-US.json'
import koKR from './ko-kr.json'
import jaJP from './ja-jp.json'
import zhCN from './zh-cn.json'
import zhTW from './zh-tw.json'

export const languageMap: Record<string, string> = {
  'ko-KR': '한국어',
  'en-US': 'English',
  'ja-JP': '日本語',
  'zh-CN': '简体中文',
  'zh-TW': '繁體中文',
}

export const supportedLocales = Object.keys(languageMap) as Array<keyof typeof languageMap>

export const localeOptions = supportedLocales.map((value) => ({
  value,
  label: languageMap[value],
}))

export type SupportedLocale = keyof typeof languageMap

// define the locale message schema as master
export type MessageSchema = typeof enUS

// define the number format schema
export type NumberSchema = {
  currency: {
    style: 'currency'
    currencyDisplay: 'symbol'
    currency: string
  }
}

const options: I18nOptions = {
  legacy: false,
  locale: localStorage.getItem('app-locale') || 'en-US',
  fallbackLocale: 'en-US',
  messages: {
    'ko-KR': koKR,
    'en-US': enUS,
    'ja-JP': jaJP,
    'zh-CN': zhCN,
    'zh-TW': zhTW
  },
  datetimeFormats: {
    'ko-KR': {
      short: {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZoneName: 'short',
        timeZone: 'Asia/Seoul'
      }
    },
    'ja-JP': {
      short: {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZoneName: 'short',
        timeZone: 'Asia/Tokyo'
      }
    }
  },
  numberFormats: {
    'ko-KR': {
      currency: {
        style: 'currency',
        currencyDisplay: 'symbol',
        currency: 'KRW'
      }
    },
    'ja-JP': {
      currency: {
        style: 'currency',
        currencyDisplay: 'symbol',
        currency: 'JPY'
      }
    }
  }
}

export const i18n = createI18n<false, typeof options>(options)
